/* eslint-disable global-require */
const sfxCuriosoCommon = {
  hub_curioso_emote_1_sfx: require('./hub_curioso_emote_1_sfx.mp3'),
  hub_curioso_emote_2_sfx: require('./hub_curioso_emote_2_sfx.mp3'),
  hub_curioso_emote_3_sfx: require('./hub_curioso_emote_3_sfx.mp3'),
  hub_curioso_emote_4_sfx: require('./hub_curioso_emote_4_sfx.mp3'),
  hub_curioso_emote_5_sfx: require('./hub_curioso_emote_5_sfx.mp3'),
  affirmative: require('./sfx_curioso_affirmative.mp3'),
  curious: require('./sfx_curioso_curious.mp3'),
  disgusted: require('./sfx_curioso_disgusted.mp3'),
  excited: require('./sfx_curioso_excited.mp3'),
  happy: require('./sfx_curioso_happy.mp3'),
  hmm: require('./sfx_curioso_hmm.mp3'),
  proud: require('./sfx_curioso_proud.mp3'),
  sad: require('./sfx_curioso_sad.mp3'),
  very_excited: require('./sfx_curioso_very_excited.mp3'),
  curioso_entranced: require('./sfx_curioso_entranced.mp3'),
};
export default sfxCuriosoCommon;
